import React from 'react';
import clsx from "clsx";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {WHITE} from '../../utils/constants';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 4),
    height: 280,
    borderRadius: 25,
    marginBottom: 30
  }, 
  darkMode: {
    backgroundColor: 'rgb(11, 36, 62)'
  }, 
  lightMode: {
    backgroundColor: WHITE
  }
}));

export default function PaperCard({children, height, theme}) {
  const classes = useStyles();

  return (
    <Paper 
      classes={{root: clsx(classes.root, height, !theme ? classes.lightMode : classes.darkMode)}}
      elevation={0}
    >
      {children}
    </Paper>
  );
}
